export default [{
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_1.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_2.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_3.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_4.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_5.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_6.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_7.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_8.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_9.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_10.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_11.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_12.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_13.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_14.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_15.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_16.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_17.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_18.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_19.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_20.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_21.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_22.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/3jie/3jie_23.jpg"
}]


// WEBPACK FOOTER //
// ./src/pages/history/jie3.js